import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import lang from '@blade-sxp/portrait-management/lang/index';
let default_1 = class default_1 extends Vue {
    title;
    visible;
    placeholder;
    form;
    maxlength;
    get selfVisible() {
        return this.visible;
    }
    set selfVisible(val) {
        this.$emit('update:visible', val);
    }
    get allowConfirm() {
        return this.form.name.trim().length > 0;
    }
    cancelFunc() {
        this.selfVisible = false;
    }
    confirmFunc() {
        this.selfVisible = false;
        this.$emit('confirm', this.form);
    }
};
__decorate([
    Prop()
], default_1.prototype, "title", void 0);
__decorate([
    Prop()
], default_1.prototype, "visible", void 0);
__decorate([
    Prop()
], default_1.prototype, "placeholder", void 0);
__decorate([
    Prop()
], default_1.prototype, "form", void 0);
__decorate([
    Prop({ default: 50 })
], default_1.prototype, "maxlength", void 0);
default_1 = __decorate([
    Component({
        i18n: { messages: lang },
    })
], default_1);
export default default_1;
